import styles from './styles/index.module.scss';

type Props = {
  name: string,
  type?: string,
  required?: boolean,
  value: string,
  onInput: React.FormEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  placeholder?: string,
  width?: 'age' | 'normal' | 'long',
  autocomplete?: 'name' | 'email' | 'tel',
};

export default function Input({ name, type, required, value, onInput, placeholder, width = 'normal', autocomplete }: Props ) {

  return (
    <>
      <input className={styles.input} data-width={width} type={type} name={name} required={required} value={value} onInput={onInput} placeholder={placeholder} autoComplete={autocomplete} />
    </>

  );
}